import { render, staticRenderFns } from "./monthlyFinals.vue?vue&type=template&id=05ce4a13&scoped=true&"
import script from "./monthlyFinals.vue?vue&type=script&lang=js&"
export * from "./monthlyFinals.vue?vue&type=script&lang=js&"
import style0 from "./monthlyFinals.vue?vue&type=style&index=0&id=05ce4a13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce4a13",
  null
  
)

export default component.exports